export const DataMonitoringIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.5 45H32.5V52.5H27.5V45ZM40 52.5V57.5H20V52.5H40ZM50 45H10C8.01149 44.998 6.10498 44.2072 4.69889 42.8011C3.2928 41.395 2.50199 39.4885 2.5 37.5V10C2.50199 8.01149 3.2928 6.10498 4.69889 4.69889C6.10498 3.2928 8.01149 2.50199 10 2.5H50C51.9885 2.50199 53.895 3.2928 55.3011 4.69889C56.7072 6.10498 57.498 8.01149 57.5 10V37.5C57.498 39.4885 56.7072 41.395 55.3011 42.8011C53.895 44.2072 51.9885 44.998 50 45ZM10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10V37.5C7.5 38.163 7.76339 38.7989 8.23223 39.2678C8.70107 39.7366 9.33696 40 10 40H50C50.663 40 51.2989 39.7366 51.7678 39.2678C52.2366 38.7989 52.5 38.163 52.5 37.5V10C52.5 9.33696 52.2366 8.70107 51.7678 8.23223C51.2989 7.76339 50.663 7.5 50 7.5H10Z"
                fill="url(#paint0_linear_326_3197)"/>
            <path
                d="M40 37.5L35.215 21.55L32.5 32.5L29.2275 25H28.4L25 35L22.1075 24.8325L20.7725 27.5H12.5V25H19.2275L22.5 17.5L25.17 26.7825L26.6 22.5H30.7725L31.99 24.9325L35 10L40 30L41.6 25H47.5V27.5H43.4L40 37.5Z"
                fill="url(#paint1_linear_326_3197)"/>
            <defs>
                <linearGradient id="paint0_linear_326_3197" x1="33.7931" y1="-28.2353" x2="109.186" y2="89.487"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_326_3197" x1="32.4138" y1="-5.36765" x2="65.7419" y2="60.865"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};